<template>
  <div class="w-100">
    <div v-if="!loaded && size === 'sm'" class="w-100">
      <vue-content-loading v-for="i in 5" :key="i" :width="1920" :height="200" class="mb-5">
        <rect x="5" y="20" rx="0" ry="0" width="100%" height="32" />
        <rect x="5" y="63" rx="0" ry="0" width="25%" height="120" />
        <rect x="26%" y="63" rx="0" ry="0" width="25%" height="120" />
        <rect x="52%" y="63" rx="0" ry="0" width="25%" height="120" />
        <rect x="78%" y="63" rx="0" ry="0" width="25%" height="120" />
      </vue-content-loading>
    </div>
    <div v-if="!loaded && size === 'lg'">
      <vue-content-loading :width="1920" :height="600" class="mb-5">
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="200" />
        <rect x="5" y="220" rx="0" ry="0" width="25%" height="400" />
        <rect x="26%" y="220" rx="0" ry="0" width="25%" height="400" />
        <rect x="52%" y="220" rx="0" ry="0" width="25%" height="400" />
        <rect x="78%" y="220" rx="0" ry="0" width="25%" height="400" />
      </vue-content-loading>
    </div>
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading'

export default {
  name: 'loader',

  components: {
    VueContentLoading,
  },

  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'sm',
    },
  },
}
</script>

<style scoped></style>
